import {
  UserReducer
} from './userSlice';

const user = (state: UserReducer) => state.user;

export const userSelectors = {
  user,
};
